const initGalleryLightbox = () => {
	const galleries = document.querySelectorAll( '.gallery-lightbox' );

	galleries.forEach( ( dialog ) => {
		const images = JSON.parse( dialog.dataset.galleryImages || '[]' );
		const galleryId = dialog.dataset.dialog;
		const figure = dialog.querySelector( '.gallery-lightbox__figure' );
		const imageEl = dialog.querySelector( '.gallery-lightbox__image' );
		const captionEl = dialog.querySelector( '.gallery-lightbox__caption' );
		const currentEl = dialog.querySelector( '[data-gallery-current]' );
		const prevBtn = dialog.querySelector( '[data-gallery-prev]' );
		const nextBtn = dialog.querySelector( '[data-gallery-next]' );

		let currentIndex = 0;
		let isAnimating = false;

		const updateImage = ( index, direction = 'none' ) => {
			if ( index < 0 || index >= images.length || isAnimating ) {
				return;
			}

			isAnimating = true;
			currentIndex = index;
			const image = images[index];

			// Determine animation class based on direction
			let exitClass = 'gallery-lightbox__figure--fade-out';
			let enterClass = 'gallery-lightbox__figure--fade-in';

			if ( direction === 'next' ) {
				exitClass = 'gallery-lightbox__figure--slide-out-left';
				enterClass = 'gallery-lightbox__figure--slide-in-right';
			} else if ( direction === 'prev' ) {
				exitClass = 'gallery-lightbox__figure--slide-out-right';
				enterClass = 'gallery-lightbox__figure--slide-in-left';
			}

			// Fade/slide out
			figure.classList.add( exitClass );

			setTimeout( () => {
				// Update image source
				imageEl.src = image.url;
				imageEl.alt = image.alt || '';

				if ( image.caption ) {
					captionEl.textContent = image.caption;
					captionEl.style.display = 'block';
				} else {
					captionEl.textContent = '';
					captionEl.style.display = 'none';
				}

				if ( currentEl ) {
					currentEl.textContent = index + 1;
				}

				// Update button states
				prevBtn.disabled = index === 0;
				nextBtn.disabled = index === images.length - 1;

				// Remove exit class, add enter class
				figure.classList.remove( exitClass );
				figure.classList.add( enterClass );

				setTimeout( () => {
					figure.classList.remove( enterClass );
					isAnimating = false;
				}, 300 );
			}, 200 );
		};

		// Focus management
		let lastFocusedElement = null;
		const focusableElements = 'button:not([disabled])';

		const trapFocus = ( e ) => {
			const focusable = dialog.querySelectorAll( focusableElements );
			const firstFocusable = focusable[0];
			const lastFocusable = focusable[focusable.length - 1];

			if ( e.key === 'Tab' ) {
				if ( e.shiftKey ) {
					if ( document.activeElement === firstFocusable ) {
						e.preventDefault();
						lastFocusable.focus();
					}
				} else {
					if ( document.activeElement === lastFocusable ) {
						e.preventDefault();
						firstFocusable.focus();
					}
				}
			}
		};

		// Handle open buttons with specific index
		const openButtons = document.querySelectorAll( `[data-open-dialog="${galleryId}"]` );
		openButtons.forEach( ( button ) => {
			button.addEventListener( 'click', () => {
				lastFocusedElement = document.activeElement;
				const index = parseInt( button.dataset.galleryIndex, 10 ) || 0;
				updateImage( index );

				// Focus close button after dialog opens
				setTimeout( () => {
					const closeBtn = dialog.querySelector( '[data-close-dialog]' );
					if ( closeBtn ) {
						closeBtn.focus();
					}
				}, 100 );
			} );
		} );

		// Restore focus when dialog closes
		dialog.addEventListener( 'close', () => {
			if ( lastFocusedElement ) {
				lastFocusedElement.focus();
				lastFocusedElement = null;
			}
		} );

		// Add focus trap listener
		dialog.addEventListener( 'keydown', trapFocus );

		// Navigation
		prevBtn.addEventListener( 'click', ( e ) => {
			e.stopPropagation();
			updateImage( currentIndex - 1, 'prev' );
		} );

		nextBtn.addEventListener( 'click', ( e ) => {
			e.stopPropagation();
			updateImage( currentIndex + 1, 'next' );
		} );

		// Keyboard navigation
		dialog.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'ArrowLeft' ) {
				e.preventDefault();
				updateImage( currentIndex - 1, 'prev' );
			} else if ( e.key === 'ArrowRight' ) {
				e.preventDefault();
				updateImage( currentIndex + 1, 'next' );
			} else if ( e.key === 'Home' ) {
				e.preventDefault();
				updateImage( 0, 'prev' );
			} else if ( e.key === 'End' ) {
				e.preventDefault();
				updateImage( images.length - 1, 'next' );
			}
		} );

		// Prevent clicks on content from closing dialog
		const content = dialog.querySelector( '.gallery-lightbox__content' );
		content.addEventListener( 'click', ( e ) => {
			e.stopPropagation();
		} );
	} );
};

document.addEventListener( 'DOMContentLoaded', initGalleryLightbox );
